import Vue from 'vue'
Vue.config.productionTip = false

import Website from '@/core/Website'

import './plugins'
// import './plugins/webiste'
import './classes'
// import './mixins'
// import '@/components/_index'

// Auth
Vue.component('login', require('@/components/Auth/Login').default);
Vue.component('join-the-club', require('@/components/Auth/JoinTheClub').default);
Vue.component('forget-password', require('@/components/Auth/ForgetPassword').default);

// Menus
Vue.component('HamburgerMenu', require('@/components/HamburgerMenu.vue').default);

// Gate
Vue.component('Testimonials', require('@/components/Gate/Testimonials').default);
Vue.component('WhyJoinTheClub', require('@/components/Gate/WhyJoinTheClub').default);
Vue.component('MemberFavorites', require('@/components/Gate/MemberFavorites').default);
Vue.component('MeetSomeMembers', require('@/components/Gate/MeetSomeMembers').default);
Vue.component('FeaturedDestinations', require('@/components/Gate/FeaturedDestinations').default);
Vue.component('Newsletter', require('@/components/Gate/Newsletter').default);


;(function () {
    this.CreateWebsite = function (config) {
        return new Website(config)
}}.call(window))
